<!-- LIQUIDACIÓN · SALUD DE LOS COBROS (SAL-04/06/09). Sin diálogos: liberar se confirma en la página, con motivo. -->
<section class="kb-card">
  <div class="kb-card-header">
    <div>
      <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-heartbeat text-muted-foreground" aria-hidden="true"></i>Salud de los cobros<ng-container *ngIf="p?.retenidos?.n"> · {{ p.retenidos.n }}</ng-container></h2>
      <p class="kb-card-desc">Cobros de la cobranza que el control retuvo antes de pagarlos. No entran en la liquidación hasta resolverse; el resto del comercio se paga igual. Al corregirse el pago se liberan solos en el control siguiente.</p>
    </div>
  </div>
  <div class="flex flex-col gap-[16px] px-[24px] pb-[20px]">
    <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
    </div>
    <div class="kb-cinta kb-cinta-info" *ngIf="aviso" role="status">
      <i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i><span>{{ aviso }}</span>
    </div>
    <p class="kb-hint" *ngIf="cargando">Revisando los cobros retenidos…</p>

    <div class="kb-empty" *ngIf="!cargando && p && !p.retenidos.n">
      <span class="kb-empty-icono"><i class="fas fa-check" aria-hidden="true"></i></span>
      <p class="kb-empty-titulo">No hay cobros retenidos</p>
      <p class="kb-empty-texto">El control de salud no encontró incidencias en los cobros por liquidar.<ng-container *ngIf="p.liberados.n"> Liberados en los últimos 30 días: {{ p.liberados.n }}.</ng-container></p>
    </div>

    <ng-container *ngIf="p && p.retenidos.n">
      <div class="kb-cifras">
        <div><p class="kb-dato-et">Retenidos</p><p class="kb-dato-val">{{ p.retenidos.n }}</p><p class="kb-dato-nota">$ {{ p.retenidos.monto | number:'1.2-2':'es' }} · en 30 días: {{ p.liberados.n }} liberados, {{ p.resueltos.n }} resueltos</p></div>
        <div *ngFor="let x of p.por_causa"><p class="kb-dato-et">{{ nombreCausa(x.causa) }}</p><p class="kb-dato-val">{{ x.n }}</p><p class="kb-dato-nota">$ {{ x.monto | number:'1.2-2':'es' }}</p></div>
      </div>
      <div class="kb-cinta !m-0" *ngIf="p.viejos" role="alert">
        <i class="fas fa-exclamation-triangle kb-cinta-icono" aria-hidden="true"></i>
        <span><strong class="font-medium">{{ p.viejos }} con más de 5 días hábiles retenido{{ p.viejos === 1 ? '' : 's' }}.</strong> Avisar a la gerente de finanzas.</span>
      </div>
    </ng-container>
  </div>

  <div class="kb-table-envoltorio" *ngIf="p && p.retenidos.n">
    <table class="kb-table">
      <thead class="kb-thead"><tr>
        <th class="kb-th">Causa</th><th class="kb-th">Venta</th><th class="kb-th">Comercio</th><th class="kb-th kb-th-num">USD</th>
        <th class="kb-th">Retenido</th><th class="kb-th">Cómo se resuelve</th><th class="kb-th"><span class="sr-only">Acción</span></th>
      </tr></thead>
      <tbody>
        <ng-container *ngFor="let c of p.casos">
          <tr class="kb-tr">
            <td class="kb-td"><span class="kb-badge kb-badge-alerta">{{ nombreCausa(c.causa) }}</span>
              <span class="kb-td-sub block" *ngIf="c.causas?.length > 1">también: {{ c.causas.slice(1).map(nombreCausa).join(', ') }}</span></td>
            <td class="kb-td"><span class="kb-td-mono">{{ c.venta || '—' }}</span></td>
            <td class="kb-td">{{ c.merchant_code }}</td>
            <td class="kb-td kb-td-num font-semibold">{{ c.monto | number:'1.2-2':'es' }}</td>
            <td class="kb-td">desde el {{ c.desde | date:'dd/MM':'UTC' }}<span class="kb-td-sub block">{{ c.dias_habiles }} día{{ c.dias_habiles === 1 ? '' : 's' }} hábil{{ c.dias_habiles === 1 ? '' : 'es' }}</span>
              <span class="kb-badge kb-badge-alerta" *ngIf="c.viejo">más de 5 días hábiles</span></td>
            <td class="kb-td text-sm">{{ comoSeResuelve(c.causa) }}</td>
            <td class="kb-td">
              <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" *ngIf="puedeLiberar && liberando !== c.abono" (click)="liberando = c.abono; motivo = ''; error = ''">Liberar</button>
            </td>
          </tr>
          <tr class="kb-tr" *ngIf="puedeLiberar && liberando === c.abono">
            <td class="kb-td" colspan="7">
              <div class="flex flex-wrap items-end gap-2">
                <label class="kb-label" [for]="'lib-' + c.abono">Motivo para liberar (el pago es correcto)
                  <input type="text" class="kb-input !w-full sm:!w-[420px]" [id]="'lib-' + c.abono" [(ngModel)]="motivo" maxlength="200" placeholder="Por ejemplo: tasa con 4 decimales, verificado con el comprobante">
                </label>
                <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90 kb-btn-sm" (click)="liberar(c)" [disabled]="ocupado">Liberar el cobro</button>
                <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" (click)="liberando = null; motivo = ''">Cancelar</button>
              </div>
              <p class="kb-hint !mt-2 !mb-0">Entra en la próxima liquidación del comercio y queda en la bitácora con tu motivo.</p>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</section>
